import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useOffer} from '../hooks/useOffer';
import {Offer} from '../types';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = useOffer();

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                description: '',
                email: '',
                phone: '',
                url: '',
                logoUrl: '',
            } as unknown as Offer}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
